import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { DiversionsReviewModule } from '@ruby/modules/diversions/forms/review/diversions.review.module';
import { DiversionsSubmitDetailsComponent } from '@ruby/modules/diversions/submodules/submit-details/components/diversions-submit-details.component';
import { DiversionsSubmitDetailsContainer } from '@ruby/modules/diversions/submodules/submit-details/containers/diversions-submit-details.container';
import { DiversionsSubmitDetailsRoutingModule } from '@ruby/modules/diversions/submodules/submit-details/diversions-submit-details-routing.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    DiversionsSubmitDetailsComponent,
    DiversionsSubmitDetailsContainer
  ],
  imports: [
    CommonModule,
    DiversionsSubmitDetailsRoutingModule,
    DiversionsReviewModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    NSGridModule,
    PipesModule
  ],
  exports: [
    DiversionsSubmitDetailsContainer
  ],
  providers: []
})
export class DiversionsSubmitDetailsModule {}
